import React from 'react';
import { bool, func, object, string } from 'prop-types';
import TrailResultCard from '../../cards/TrailResultCard';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

import * as styles from './styles/styles.module.scss';

const addAsTrailLink = (context, data, handleAddAsTrailClick) => {
  if (context.currentUser && !data.private) {
    return (
      <a className={styles.link} onClick={handleAddAsTrailClick}>
        {context.adminUser ? StringConstantsMixin.strings.ADD : StringConstantsMixin.strings.SUGGEST}{' '}
        {StringConstantsMixin.strings.TRACK_DETAIL.AS_NEW_TRAIL}
      </a>
    );
  }
  return null;
};

const hideStatusLink = (context, hideText, handleHideShowTrackClick) => {
  if (context.adminUser && hideText !== null) {
    return (
      <span className={styles.hideContainer}>
        <a className={styles.link} onClick={handleHideShowTrackClick}>
          {hideText}
        </a>
        <span className={styles.divider}> | </span>
      </span>
    );
  }
};

const LinkedCard = ({
  trackTrail,
  context,
  data,
  hideText,
  handleAddAsTrailClick,
  handleHideShowTrackClick,
  resultCardFunctions,
  listMethods,
  isMobileWidth,
  messagingChannel
}) => {
  const addAsTrail = addAsTrailLink(context, data, handleAddAsTrailClick);
  const hideStatus = hideStatusLink(context, hideText, handleHideShowTrackClick);
  if (trackTrail) {
    const itemID = `www.alltrails.com/${trackTrail?.slug}`;
    return (
      <div className={styles.inlineCard} itemProp="containedInPlace" itemScope itemType="http://schema.org/LocalBusiness" itemID={itemID}>
        <div className={styles.cardHeading}>
          <span className={styles.associatedWithTrail}>{StringConstantsMixin.strings.TRACK_DETAIL.LINKED_TRAIL}</span>
          <span className={styles.linksContainer}>
            {hideStatus}
            {addAsTrail}
          </span>
        </div>
        <TrailResultCard
          allowClickingCompletedBadge={() => resultCardFunctions?.allowClickingCompletedBadge(trackTrail?.type, trackTrail?.ID)}
          context={context}
          handleCardClick={() => resultCardFunctions?.handleTrailClick(trackTrail)}
          handleCompletedBadgeClick={() => resultCardFunctions?.handleCompletedBadgeClick(trackTrail?.type, trackTrail?.ID)}
          handleFavoriteClick={() => listMethods?.handleFavoriteClick(trackTrail?.type, trackTrail?.ID, trackTrail?.objectID)}
          handleLocationClick={resultCardFunctions?.handleLocationClick}
          isCompleted={listMethods?.isComplete(trackTrail?.type, trackTrail?.ID)}
          isFavorite={listMethods?.isFavorite(trackTrail?.type, trackTrail?.ID)}
          isMobileWidth={isMobileWidth}
          isVerified={listMethods?.isVerified(trackTrail?.type, trackTrail?.ID)}
          key={`trail-${trackTrail?.ID}`}
          messagingChannel={messagingChannel}
          showFavoriteHeart={listMethods?.showFavoriteHeart}
          tabletBrowser={context.tabletBrowser}
          trail={trackTrail}
        />
      </div>
    );
  }

  if (addAsTrail != null) {
    return (
      <div className={`${styles.inlineCard} ${styles.captionOnly}`}>
        <span className={styles.linksContainer}>
          {hideStatus}
          {addAsTrail}
        </span>
      </div>
    );
  }
  return null;
};

export default LinkedCard;

LinkedCard.propTypes = {
  trackTrail: object,
  context: object,
  data: object,
  hideText: string,
  handleAddAsTrailClick: func,
  handleHideShowTrackClick: func,
  resultCardFunctions: object,
  listMethods: object,
  isMobileWidth: bool,
  messagingChannel: object
};

LinkedCard.defaultProps = {
  trackTrail: {},
  context: {},
  data: {},
  hideText: string,
  handleAddAsTrailClick: () => {},
  handleHideShowTrackClick: () => {},
  resultCardFunctions: {},
  listMethods: {},
  isMobileWidth: false,
  messagingChannel: {}
};
